module.exports = __webpack_public_path__ + "img/settings-other.460e562f.svg";